<template>
  <div class="wrapper" id="premiumCalculation">
    <div class="contentModule" >
      <div class="space-between theme">
        <div>
          <div class="insuranceTheme">泰康在线车险 - 保费计算</div>
          <div class="insuranceDescription"></div>
        </div>
      </div>
      <div class="section">
        <div class="customerIcon">
          <span class="icon"></span>
        </div>
        <div class="licenseNo title" v-html="licenseNo"></div>
        <!-- 商业险 -->
        <div class="commercialInsurance insurance">
          <div class="title">
            <van-checkbox v-model="checkCommercialInsurance" @change="checkbox('commercial')" checked-color="#ff7052" class="check commercial"></van-checkbox>
            <div class="check">商业险</div>
            <div class="parameter">保费：<span class="price">待计算</span></div>
          </div>
          <div class="startDate">
            <div class="tit">
              <span>商业险生效日期：</span>
            </div>
            <div class="sInfo dateSelector" data-value="enrollDate">
              <el-date-picker
                v-model="biStartDate"
                :picker-options="biStartDateDisable"
                value-format="yyyy-MM-dd"
                type="date"
                format="yyyy 年 MM 月 dd 日"
                align="center"
                placeholder="请选择商业险生效日期"
                class="my-el-date-picker"
                :editable="false"
                @change="biStartDatePicker"
              >
              </el-date-picker>
            </div>
          </div>
          <div class="tips">
            <span>*依据您爱车的情况，智能推荐产品计划如下，可按需调整</span>
          </div>
          <div class="biList">
            <el-table
              class="tableTitle"
              border
              :data="commercialInsuranceDetailList"
              style="width: 94%">
              <el-table-column
                prop="kindName"
                label="险别"
                min-width="49%">
              </el-table-column>
              <el-table-column
                prop="label"
                :key="productPlanningKey"
                label="产品计划"
                min-width="19%">
                <template slot-scope="scope">
                  <el-select @change="amountsListPicker(scope)" v-model="scope.row.label" placeholder="请选择产品计划" >
                    <el-option
                      v-for="(item, index) in scope.row.amountsList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.label"
                    >
                    </el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column
                prop="kindFlag"
                label="不计免赔"
                min-width="15%">
              </el-table-column>
              <el-table-column
                prop="premium"
                label="保费(元)"
                min-width="15%">
              </el-table-column>
            </el-table>
          </div>
        </div>
        <!-- 驾乘保 -->
        <div class="drivingPassengerInsurance insurance" v-show="checkCommercialInsurance && this.$$.isValidMap(drivingPassengerList)">
          <div class="title">
            <van-checkbox v-model="checkDrivingPassengerInsurance" checked-color="#ff7052" class="check"></van-checkbox>
            <div class="check">驾乘保</div>
            <div class="parameter">保费：<span class="price">{{drivingPassengerInsurancePremium}}</span></div>
          </div>
          <div class="startDate">
            <div class="tit">
              <span>驾乘保生效日期：</span>
            </div>
            <div class="sInfo dateSelector" data-value="enrollDate">
              <el-date-picker
                v-model="biStartDate"
                :picker-options="biStartDateDisable"
                value-format="yyyy-MM-dd"
                type="date"
                format="yyyy 年 MM 月 dd 日"
                align="center"
                placeholder="请选择驾乘保生效日期"
                class="my-el-date-picker"
                disabled
              >
              </el-date-picker>
            </div>
          </div>

          <div class="drivingPassenger">
            <div class="drivingPassengerType">
              <div class="tit">
                <span>产品计划：</span>
              </div>
              <div class="sInfo">
                <el-select @change="drivingPassengerType" v-model="productCode" placeholder="请选择产品计划" >
                  <el-option
                    v-for="item in drivingPassengerList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                    <span style="float: left">{{ item.label }}</span>
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="sectionTitle">
              <span style="width: 49%;text-align: left">险别</span>
              <span style="width: 49%;text-align: center">保险金额(限额)</span>
            </div>
            <ul class="drivingPassengerInsuranceDetail"></ul>
          </div>
        </div>
        <!-- 交强险 -->
        <div class="autoInsuranceExtra insurance" >
          <div class="title">
            <van-checkbox v-model="checkAutoInsuranceExtra" checked-color="#ff7052" class="check"></van-checkbox>
            <div class="check autoInsuranceExtraName">交强险</div>
            <div class="parameter">保费：<span class="price">待计算</span></div>
          </div>
          <div class="isVesselTax autoInsuranceExtraUnit">
            <span>交强险</span>
            <span class="price">待计算</span>
          </div>
          <div class="isVesselTax vesselTaxUnit">
            <span>车船税</span>
            <span class="price">待计算</span>
          </div>
          <div class="startDate">
            <div class="tit">
              <span>交强险生效日期：</span>
            </div>
            <div class="sInfo dateSelector" data-value="enrollDate">
              <el-date-picker
                v-model="ciStartDate"
                :picker-options="ciStartDateDisable"
                value-format="yyyy-MM-dd"
                type="date"
                format="yyyy 年 MM 月 dd 日"
                align="center"
                placeholder="请选择交强险生效日期"
                class="my-el-date-picker"
                :editable="false"
                @change="ciStartDatePicker"
              >
              </el-date-picker>
            </div>
          </div>
        </div>
        <!-- 特别约定 -->
        <div class="engageList">
          <div class="engageListTitle">特别约定</div>
          <ul></ul>
        </div>
        <!-- 重要告知 -->
        <div class="importantNotifyList">
          <div class="engageListTitle">重要告知</div>
          <ul></ul>
        </div>
        <div>
          <span>费用合计：</span>
          <span class="totalPremium">待计算</span>
        </div>
        <div class="businessScore" v-show="businessScore">
          <span>保单综合评分：</span>
          <span class="businessScoreValue" v-html="businessScore"></span>
        </div>
        <div class="step space-around" style="margin-top: 20px">
          <button class="nextStep" id="parcelInsurance" @click="immediateInsurance('parcelInsurance')" data-value="1" >生成报价单</button>
          <button class="nextStep" id="immediateInsurance" @click="immediateInsurance()" data-value="1" onmouseover="this.style.backgroundColor='#ff8a73';" onmouseout="this.style.backgroundColor='#ff7052';" onmouseup="this.style.backgroundColor='#d95e45';">立即询价</button>
        </div>
      </div>
    </div>
    <!-- iframe弹窗 -->
    <div class="iframePreview">
      <iframe v-bind:src="iframePreviewUrl" frameborder="0" width="100%" height="100%"></iframe>
      <div class="closePreview">关闭</div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "premiumCalculation",
    data() {
      return {
        beShareToken: null,                 // 被分享token
        quoteIdNum: null,                   // 报价订单ID
        eventLogToken: null,                 // 事件日志Token

        licenseNo: null,                          // 车牌号
        checkCommercialInsurance: false,           // 商业险 - 勾选
        checkDrivingPassengerInsurance: false,     // 驾乘保 - 勾选
        checkAutoInsuranceExtra: false,            // 交强险 - 勾选
        biStartDate: '',                          // 商业险生效日期：yyyy-MM-dd
        biStartDateDisable: {                     // 商业险生效日期 - 期限
          disabledDate(time) {
            const date = new Date(Date.now());
            let days = new Date(date.getFullYear(), date.getMonth()+1, 0).getDate();
            return time.getTime() < new Date(date - (0 * 24 * 60 * 60 * 1000)) || time.getTime() > new Date(date - (-(days-1) * 24 * 60 * 60 * 1000));
          },
        },
        ciStartDate: '',                          // 交强险生效日期：yyyy-MM-dd
        ciStartDateDisable: {                     // 交强险生效日期 - 期限
          disabledDate(time) {
            const date = new Date(Date.now());
            let days = new Date(date.getFullYear(), date.getMonth()+1, 0).getDate();
            return time.getTime() < new Date(date - (0 * 24 * 60 * 60 * 1000)) || time.getTime() > new Date(date - (-(days-1) * 24 * 60 * 60 * 1000));
          },
        },
        drivingPassengerList: [],                 // 驾乘保列表
        productCode: '',                          // 驾乘保 - 产品计划
        drivingPassengerInsurancePremium: '待计算',     // 驾乘保 - 价格
        amountsList: {},                          // 商业险种保额列表
        commercialInsuranceDetailList: [{}],      // 商业险险种列表
        businessScore: null,                      // 保单综合评分
        productPlanningKey: null,                 // 商业险 - 产品计划key
        isUserQuoteRecord: false,                 // 是否有最后报价记录

        iframePreviewUrl: null,                   // iframe - 协议URL
      };
    },
    methods: {
      //-- 事件绑定
      eventBinding() {
        let that = this;

        //-- 找客服 二维码 绑定事件
        $(".customerIcon").on("click", function(){
          window.open('https://work.weixin.qq.com/kfid/kfce82ed2eaaae38c7f');
        });
      },
      checkbox(name){
        // 是否勾选 - 险种
        let that = this,
          {drivingPassengerList, productCode} = that;

        if(that.$$.isValidMap(drivingPassengerList) && name == 'commercial') that.drivingPassengerType(productCode);
      },
      biStartDatePicker(value){
        // 商业险生效日期
        // console.log(value)
      },
      amountsListPicker(scope){
        // 商业险列表 - 产品计划
        this.productPlanningKey = Math.random();

        scope.row.premium = scope.row.label != '不投保' ? '待计算':'';
      },
      ciStartDatePicker(value){
        // 交强险生效日期
        // console.log(value)
      },
      //-- 获取车辆信息
      getCarInfo(){
        let that = this;
        that.axios.post('/management/quotecarinsurance/getQuotation',{
          quoteIdNum: that.quoteIdNum,
          beShareToken: that.beShareToken,
        }).then((response) => {
          let data = response.data;
          if (data.success) {
            const {car, isLockMsg, businessScore} = data['datas'];
            // if (that.$$.isValidObj(isLockMsg)) that.$message.error(isLockMsg);

            that.licenseNo = car.licenseNo;

            // 保单综合评分
            that.businessScore = that.$$.isValidObj(businessScore) ? businessScore : null;
          } else {
            that.$message.error(data.msg);
          }
        });
      },
      //-- 险种初始化
      kindsInits(){
        let that = this;
        const {quoteIdNum, beShareToken} = that;

        that.$$.request({
          url: that.UrlConfig.management_quotecarinsurance_kindsInit,
          pars: {
            quoteIdNum,
            beShareToken,
          },
          requestBody: true,
          loading: true,
          sfn: function (data) {
            that.$$.closeLoading();

            const { success, msg, datas } = data;
            if (success) {
              Object.assign(that.$data, datas);
              responseHandler(datas);
            } else {
              if (that.$$.isValidObj(datas)) {
                const {priceQuoteEffective} = datas;
                if (that.$$.isValidObj(priceQuoteEffective) && !priceQuoteEffective) {
                  that.$$.alert({message: msg == 'carModelExpire' ? '报价超时，请重新报价' : msg, onOk: function () {
                      let data = {};
                      if (that.$$.isValidObj(beShareToken)) data['beShareToken'] = beShareToken;
                      if (that.$$.isValidObj(quoteIdNum)) data['quoteIdNum'] = quoteIdNum;

                      that.$router.push({path: '/taiKang/vehicleInfo', query: data});
                  }});
                }
              }else {
                that.$message.error(msg);
              }
            }
          },
          ffn: function (data) {
            that.$$.errorHandler();
          }
        });

        function responseHandler(data) {
          const {kindsInit, userQuoteRecord} = data;

          that.insuranceList = kindsInit;
          const {actualValue, bi, ci, ri} = kindsInit;

          // 驾乘保
          (function(){
            if (that.$$.isValidObj(ri) && that.$$.isValidMap(ri)){
              for (let i in ri){
                let {productCode, productName, dutys} = ri[i];
                that.drivingPassengerList.push({label: productName, value: productCode, dutys});
              }

              that.setDrivingPassengerInsurance(that.drivingPassengerList[0]);
            }
          })();

          // 商业险
          (function(){
            let {startDate, list} = bi;

            // 商业险起始生效时间
            let biStartDate = that.$$.dateFormat(new Date(startDate.replace(/-/g,'/')), "yyyy-MM-dd HH:mm:ss");
            that.biStartDate = biStartDate;

            // 商业险 - 子险种列表
            let value = '',
              label = '';

            for (let i in list){
              let amountsList = [];
              let {amount, quantity, defaultFlag, kindCode, amounts, kindName, unitAmount, modeCode, deductibleAmount, kindFlag, miles, deductibleRates} = list[i];

              if (defaultFlag == '0') {
                value = '不投保';
                label = '不投保';
              }else if (defaultFlag == '1') {
                that.checkCommercialInsurance = true;

                value = that.$$.isValidObj(unitAmount) && parseFloat(unitAmount) != 0 ? unitAmount : amount;
                label = that.$$.isValidObj(unitAmount) && parseFloat(unitAmount) != 0 ? that.unitConversion(unitAmount) : that.unitConversion(amount);
              }

              if (that.$$.isValidObj(amounts)){
                let lists = amounts.split(',');

                for (let a in lists){
                  let num = that.unitConversion(lists[a]);
                  amountsList[a] = {label: num, value: lists[a]};
                }
                amountsList.unshift({label: '不投保', value: '不投保'});
              }else {
                // 增值服务险别
                if ('74,75,76,77,274,275,276,277'.includes(kindCode)) {
                  amountsList = [{label: '不投保', value: '不投保'}, {label: `${quantity}次`, value: amount}];

                  if (defaultFlag == '1') {
                    label = `${quantity}次`;
                    value = `${quantity}次`;
                  }
                }else {
                  amountsList = [{label: '不投保', value: '不投保'}, {label: that.unitConversion(amount), value: amount}];

                  if (defaultFlag == '1') {
                    label = that.unitConversion(amount);
                    value = amount;
                  }
                }
              }

              // 附加绝对免赔率特约险
              if ('701,702,703,704'.includes(kindCode)) {
                amountsList = [];
                let lists = deductibleRates.split(',');

                for (let a in lists){
                  let num = (lists[a] * 100) + '%';
                  amountsList[a] = {label: num, value: lists[a]};
                }
                amountsList.unshift({label: '不投保', value: '不投保'});

                if (defaultFlag == '1') {
                  label = amountsList[1].label;
                  value = amountsList[1].value;
                }
              }

              if (that.$$.isValidMap(amountsList)) that.amountsList[i] = amountsList;

              // 商业险 - 险种列表
              that.commercialInsuranceDetailList[i] = {
                kindName,
                amountsList,
                label,
                kindCode,
                quantity,
                kindFlag: that.$$.isValidObj(kindFlag) && kindFlag == '1' ? '√':'',
                premium: label == '不投保' ? '':'待计算',
              };
            }

          })();

          // 交强险
          (function(){
            let {startDate, defaultFlag} = ci;

            // 交强险起始生效时间
            let ciStartDate = that.$$.dateFormat(new Date(startDate.replace(/-/g,'/')), "yyyy-MM-dd HH:mm:ss");
            that.ciStartDate = ciStartDate;

            if (that.$$.isValidObj(defaultFlag) && defaultFlag == '1') {
              that.checkAutoInsuranceExtra = true;
            }
          })();

          // 用户最后报价记录
          (function(){
            if (that.$$.isValidMap(userQuoteRecord)) {
              const {bi, ci, ri, sumPremium} = userQuoteRecord;
              let commercialList = that.commercialInsuranceDetailList;

              $('#immediateInsurance').html('重新报价');

              // 商业险
              if (that.$$.isValidObj(bi) && that.$$.isValidMap(bi)){
                that.checkCommercialInsurance = true;

                const {disCount, startDate, list} = bi;

                // 遍历险别列表
                let label, premiums;
                for (let i in commercialList){
                  let {quantity} = commercialList[i];
                  label = '';
                  premiums = '';

                  for (let j in list){
                    let {amount, premium, kindCode, deductibleRate, unitAmount} = list[j];

                    if (commercialList[i].kindCode == kindCode){
                      label = that.unitConversion(amount);

                      // 增值服务险别
                      if ('74,75,76,77,274,275,276,277'.includes(kindCode)) {
                        label = `${quantity}次`;
                      }

                      // 附加绝对免赔率特约险
                      if ('701,702,703,704,705'.includes(kindCode)) {
                        label = `${(deductibleRate * 100)}%`;
                      }

                      if (that.$$.isValidObj(unitAmount) && parseFloat(unitAmount) > 0){
                        label = that.unitConversion(unitAmount);
                      }

                      premiums = premium == '0' ? '0:00' : premium;
                    }
                  }
                  if (label == '') label = '不投保';
                  that.commercialInsuranceDetailList[i].label = label;
                  that.commercialInsuranceDetailList[i].premium = premiums;
                }

                // 商业险价格
                $('.commercialInsurance .parameter .price').html('￥' + bi.premium);
                // 商业险 - 起始时间
                that.biStartDate = startDate;
              }else {
                that.checkCommercialInsurance = false;
              }

              // 驾乘保
              if (that.$$.isValidObj(ri) && that.$$.isValidMap(ri)){
                const {premium, productCode} = ri;
                that.checkDrivingPassengerInsurance = true;

                // 驾乘保价格
                that.drivingPassengerInsurancePremium = '￥' +premium;

                let list = that.drivingPassengerList;
                for (let i in list){
                  if (list[i].value == productCode){
                    that.setDrivingPassengerInsurance(list[i]);
                  }
                }
              }

              // 交强险
              if (that.$$.isValidObj(ci) && that.$$.isValidMap(ci)){
                that.checkAutoInsuranceExtra = true;

                let {disCount, startDate, premium, tax, sumCiAndTax} = ci;

                if (that.$$.isValidObj(tax) && parseFloat(tax) > 0){
                  $('.autoInsuranceExtraName').html('交强险+车船税');
                  $('.isVesselTax').show();
                  $('.autoInsuranceExtraUnit .price').html('￥' + premium);
                  $('.vesselTaxUnit .price').html('￥' + tax);
                }else {
                  $('.autoInsuranceExtraName').html('交强险');
                  $('.isVesselTax').hide();
                }

                // 交强险价格
                $('.autoInsuranceExtra .parameter .price').html('￥' + sumCiAndTax);

                // 商业险 - 起始时间
                that.ciStartDate = startDate;

              }else {
                that.checkAutoInsuranceExtra = true;
              }

              // 费用合计
              $('.totalPremium').html('￥' + sumPremium);

              // 可以生成报价书
              that.isUserQuoteRecord = true;
              $('#parcelInsurance').addClass('isVerify');
            }
          })();

          // 产品屏幕录制
          let eventLogToken = decodeURIComponent(encodeURIComponent(that.eventLogToken).replace(new RegExp("%20","gm"),"%2B"));
          if (that.$$.isValidObj(eventLogToken)) {
            that.screenRecBase.startLoad();
            that.eventLogToken = eventLogToken;
          }
        }
      },
      // 驾乘保 - 产品计划
      drivingPassengerType(values){
        let that = this,
          list = that.drivingPassengerList;

        for (let i in list){
          const {value} = list[i];
          if (value == values) that.setDrivingPassengerInsurance(list[i]);
        }

      },
      // 设置驾乘保
      setDrivingPassengerInsurance(data) {
        let that = this,
          {value, label, dutys} = data,
          html = ``;
        that.productCode = value;

        for (let i in dutys){
          const {amount, kindName} = dutys[i];
          html += `<li>
                      <div>${kindName}</div>
                      <div>${that.unitConversion(amount)}</div>
                  </li>`;
        }
        $('.drivingPassengerInsuranceDetail').html(html);
      },
      // 数值转化 - 万
      unitConversion(num) {
        if (num.toString().includes('.')) return num;
        num = Number(num);
        if (num < 10000) {
          return num + '';
        } else {
          return (num / 10000) + '万';
        }
      },
      //-- 立即询价
      immediateInsurance(name){
        let that = this;
        if (name == 'parcelInsurance' && !that.isUserQuoteRecord) return;

        let {
          beShareToken,                   // 分享token
          quoteIdNum,                     // 报价订单ID
          insuranceList: {                // 险种Code列表
            bi,
            ci
          },
          checkCommercialInsurance,           // 商业险 - 勾选
          checkDrivingPassengerInsurance,     // 驾乘保 - 勾选
          checkAutoInsuranceExtra,            // 交强险 - 勾选
          biStartDate,                        // 商业险生效日期：yyyy-MM-dd
          ciStartDate,                        // 交强险生效日期：yyyy-MM-dd
          productCode,                        // 驾乘保 - 产品计划
          commercialInsuranceDetailList,      // 商业险险种列表
        } = that;

        if (!that.$$.isValidObj(bi) || !that.$$.isValidObj(ci)){
          that.$$.throwTips('无险种信息，无法询价！');
        }

        let params = {
          beShareToken,                   // 分享token
          quoteIdNum,                     // 报价订单ID
        };

        //-- 数据校验 + 数据处理
        (function(){
          if (!checkCommercialInsurance && !checkAutoInsuranceExtra) that.$$.throwTips("请选择最少一款险种");

          // 商业险
          if (checkCommercialInsurance){
            let {list, riskCode} = bi;

            let kindList = [],
              amount = '',
              commercialList = commercialInsuranceDetailList;

            for (let i in commercialList){
              amount = '不投保';
              let {amountsList, label, kindFlag} = commercialList[i],
                {quantity, kindCode, unitAmount, modeCode, miles, deductibleRates, amounts} = list[i],
                deductibleRate = '';

              for (let j in amountsList){
                if (amountsList[j].label == label) amount = amountsList[j].value;
              }

              if (amount != '不投保') {
                if ('701,702,703,704'.includes(kindCode)){
                  deductibleRate = amount;
                  amount = '0';
                }

                if (kindCode == '107'){
                  quantity = '1';
                  unitAmount = amounts.split(',')[0];
                }

                if (that.$$.isValidObj(unitAmount) && parseFloat(unitAmount) > 0){
                  unitAmount = amount;
                  amount = parseInt(quantity) * parseInt(unitAmount);
                }

                kindList.push({
                  kindCode,
                  unitAmount: unitAmount,
                  quantity: quantity,
                  kindFlag: that.$$.isValidObj(kindFlag) ? kindFlag : '',
                  modeCode,
                  miles,
                  deductibleRate,
                  amount,
                });
              }
            }

            let endDate = new Date(biStartDate.toString());
            endDate.setFullYear(endDate.getFullYear() + 1);
            endDate.setDate(endDate.getDate() - 1);
            endDate = that.$$.dateFormat(endDate) + ' 24:00';

            let biStartDates = that.$$.dateFormat(new Date(biStartDate.replace(/-/g,'/')), "yyyy-MM-dd HH:mm:ss");

            params.bi = {
              "startDate": biStartDates,
              "endDate": endDate,
              "riskCode": riskCode,
              "expectDiscount": "",
              "kindList": kindList,
            };

            // 驾乘保
            if (checkDrivingPassengerInsurance){
              params.ri = {
                "startDate": biStartDates,
                "endDate": endDate,
                "productCode": productCode,
              }
            }
          }

          // 交强险
          if (checkAutoInsuranceExtra){
            let {riskCode, kindCode, amount} = ci;

            let endDate = new Date(ciStartDate.toString());
            endDate.setFullYear(endDate.getFullYear() + 1);
            endDate.setDate(endDate.getDate() - 1);
            endDate = that.$$.dateFormat(endDate) + ' 24:00';

            let ciStartDates = that.$$.dateFormat(new Date(ciStartDate.replace(/-/g,'/')), "yyyy-MM-dd HH:mm:ss");

            params.ci = {
              "startDate": ciStartDates,
              "endDate": endDate,
              "riskCode": riskCode,
              "kindCode": kindCode,
              "amount": amount,
            }
          }
        })();

        // console.log(params);
        // return;
        that.priceQuote(params, name);
      },
      // 保存险别险种及询价
      priceQuote(params, name){
        let that = this;
        const {quoteIdNum, beShareToken, eventLogToken} = that;

        that.$$.request({
          url: that.UrlConfig.management_quotecarinsurance_priceQuote,
          pars: params,
          requestBody: true,
          loading: true,
          sfn: function (data) {
            that.$$.closeLoading();

            const { success, msg, datas } = data;
            if (success) {
              that.$message.success('报价成功~');

              if (name == 'parcelInsurance'){
                let data = {};
                if (that.$$.isValidObj(beShareToken)) data['beShareToken'] = beShareToken;
                if (that.$$.isValidObj(eventLogToken)) data['eventLogToken'] = eventLogToken;
                if (that.$$.isValidObj(quoteIdNum)) data['quoteIdNum'] = quoteIdNum;

                that.$router.push({path: '/taiKang/fillInfo', query: data});
              }else {
                // 可以生成报价书
                that.isUserQuoteRecord = true;
                $('#parcelInsurance').addClass('isVerify');

                responseHandler(datas);
              }
            }else{
              // 报价单失效
              if (that.$$.isValidObj(datas)) {
                const {priceQuoteEffective} = datas;
                if (that.$$.isValidObj(priceQuoteEffective) && !priceQuoteEffective) {
                  that.$$.alert({message: '报价超时，请重新报价', onOk: function () {
                      let data = {};
                      if (that.$$.isValidObj(beShareToken)) data['beShareToken'] = beShareToken;
                      if (that.$$.isValidObj(quoteIdNum)) data['quoteIdNum'] = quoteIdNum;

                      that.$router.push({path: '/taiKang/vehicleInfo', query: data});
                  }});
                }
              }else {
                that.$message.error(msg);
              }
            }
          },
          ffn: function (data) {
            that.$$.errorHandler();
          }
        });

        function responseHandler(datas) {
          const {bi, ci, ri, engageMap, importantNotify, sumPremium, businessScore} = datas;

          // 商业险
          if (that.$$.isValidObj(bi) && that.$$.isValidMap(bi) && that.$$.isValidMap(bi.list)){
            const {disCount, list} = bi;

            // 遍历险别列表
            let premiums;
            let commercialList = that.commercialInsuranceDetailList;
            for (let i in commercialList){
              premiums = '';

              for (let j in list){
                let { premium, kindCode} = list[j];

                if (commercialList[i].kindCode == kindCode){
                  premiums = premium == '0' ? '0:00' : premium;
                }
              }
              that.commercialInsuranceDetailList[i].premium = premiums;
            }

            // 商业险价格
            $('.commercialInsurance .parameter .price').html('￥' + bi.premium);
          }

          // 驾乘保
          if (that.$$.isValidObj(ri) && that.$$.isValidMap(ri)){
            // 驾乘保价格
            that.drivingPassengerInsurancePremium = '￥' + ri.premium;
          }

          // 交强险
          if (that.$$.isValidObj(ci) && that.$$.isValidMap(ci)){
            let {disCount, premium, tax, sumCiAndTax} = ci;

            if (that.$$.isValidObj(tax) && parseFloat(tax) > 0){
              $('.autoInsuranceExtraName').html('交强险+车船税');
              $('.isVesselTax').show();
              $('.autoInsuranceExtraUnit .price').html('￥' + premium);
              $('.vesselTaxUnit .price').html('￥' + tax);
            }else {
              $('.autoInsuranceExtraName').html('交强险');
              $('.isVesselTax').hide();
            }

            // 交强险价格
            $('.autoInsuranceExtra .parameter .price').html('￥' + sumCiAndTax);
          }

          // 费用合计
          $('.totalPremium').html('￥' + sumPremium);

          // 保单综合评分
          that.businessScore = that.$$.isValidObj(businessScore) ? businessScore : null;

          // 特别约定
          let engageHtml = ``;
          for (let i in engageMap){
            if (i == '广东销售信息特别约定') continue;

            engageHtml += `<li>
                    <span>${i}:</span>
                    <span class="details">${engageMap[i]}</span>
                </li>`;
          }
          $('.engageList').addClass('on').find('ul').html(engageHtml);

          // 条款
          let importantNotifyHtml = ``;
          for (let i in importantNotify){
            importantNotifyHtml += `<li><div class="openIframe" data-url="${importantNotify[i]}">《${i}》</div></li>`;
          }
          // $('.importantNotifyList').addClass('on').find('ul').html(importantNotifyHtml);

          //-- 打开 - iframe弹窗
          $(".openIframe").off().click(function(){
            let url = $(this).attr('data-url');

            if (that.$$.isValidObj(url)) {
              // $('.iframePreview').show().find('iframe').attr('src', url);
              $('.iframePreview').show();
              that.iframePreviewUrl = url;
            }
          });

          //-- 关闭 - iframe弹窗
          $(".closePreview").on("click", function(){
            // $('.iframePreview').hide().find('iframe').attr('src', '');
            $('.iframePreview').hide();
            that.iframePreviewUrl = '';
          });
        }
      },
    },
    mounted() {
      let that = this,
        quoteIdNum = that.$route.query.quoteIdNum,
        eventLogToken = that.$route.query.eventLogToken,
        beShareToken = that.$route.query.beShareToken;

      if (that.$$.isValidObj(eventLogToken)) that.eventLogToken = eventLogToken;
      if (that.$$.isValidObj(beShareToken)) that.beShareToken = beShareToken;
      if (that.$$.isValidObj(quoteIdNum)) {
        let id = decodeURIComponent(encodeURIComponent(quoteIdNum.toString()).replace(new RegExp("%20","gm"),"%2B"));
        that.quoteIdNum = id;
        that.getCarInfo();
        that.kindsInits();
      }

      // 事件绑定
      that.eventBinding();
    }
  }
</script>

<style scoped>
  @import "../../../../../static/css/dutyInsurance/fillInfo.css";

  .wrapper{
    overflow-x: auto;
  }

  /deep/ .arrow {
    position: relative;
  }

  .section{
    position: relative;
    min-width: 1000px;
    margin: 0 auto;
    padding: 2rem 5%;
    background: #FFFFFF;
    box-shadow: 0 0 1rem 0 rgba(203, 203, 203, 0.2);
  }

  .section .title{
    padding: 10px 3%;
    background-color: #f2f2f2;
    color: #727272;
    font-weight: bold;
    font-size: 16px;
  }

  .customerIcon{
    width: 40px;
    height: 30px;
    background: #5677fc;
    display: inline-block;
    position: absolute;
    right: 0;
    border-radius: 20px 0 0 20px;
    top: -35px;
    z-index: 2;
  }
  .customerIcon .icon{
    background: url('../../../../../static/images/public/autoInsurance/customerIcon.png') no-repeat;
    width: 21px;
    height: 18px;
    display: inline-block;
    background-size: contain;
    margin-top: 6px;
    margin-left: 12px;
  }

  .check{
    display: inline-block;
    vertical-align: middle;
    margin-right: 5px;
  }

  .licenseNo{
    margin-bottom: 10px;
    font-size: 16px;
  }

  .insurance{
    border: 1px solid #dddddd;
    margin-bottom: 20px;
  }

  .section input::-webkit-input-placeholder {
    font-size: 14px!important;
  }

  .section /deep/ .el-input__inner,
  .section /deep/ .el-select,
  .section /deep/ .el-cascader{
    width: 260px;
    color: #ff7052;
  }

  .tit {
    color: #727272;
    letter-spacing: 1px;
    display: inline-block;
    text-align: right;
  }

  .sInfo{
    height: 100%;
    line-height: 40px;
    padding-left: 10px;
    color: #ff7052;
    display: inline-block;
    position: relative;
  }

  .startDate{
    text-align: center;
    padding: 15px 0;
  }

  .tips{
    font-size: 12px;
    color: #ff7052;
    padding: 10px 3% 5px;
  }

  .sectionTitle{
    padding: 10px 3%;
    background-color: #f2f2f2;
    color: #727272;
    border: 1px solid #dddddd;
    border-bottom: none;
    font-size: 13px;
    margin: 0 3%;
  }
  .sectionTitle span{
    display: inline-block;
    vertical-align: middle;
  }

  .totalPremium {
    color: #ff7052!important;
    font-size: 16px;
    font-weight: bold;
  }

  #parcelInsurance{
    background-color: #A9A9A9;
    color: white;
  }
  #parcelInsurance.isVerify{
    background-color: #ffffff;
    color: #ff7052;
    border: 1px solid #ff7052;
  }

  .drivingPassengerType{
    padding: 10px 3% 5px;
  }

  .drivingPassengerInsuranceDetail{
    margin: 0 3% 20px;
    border: 1px solid #f2f2f2;
  }
  .drivingPassengerInsuranceDetail /deep/ li {
    position: relative;
    z-index: 1;
    padding: 10px 0;
    margin: 0 3%;
    font-size: 12px;
    border-bottom: 1px solid #f5f5f5;
  }
  .drivingPassengerInsuranceDetail /deep/ li>div {
    display: inline-block;
    vertical-align: middle;
  }
  .drivingPassengerInsuranceDetail /deep/ li>div:nth-child(1){
    width: 49%;
    text-align: left;
  }
  .drivingPassengerInsuranceDetail /deep/ li>div:nth-child(2){
    width: 49%;
    text-align: center;
  }

  .commercialInsuranceDetail{
    margin: 0 3% 20px;
    border: 1px solid #f2f2f2;
  }
  .commercialInsuranceDetail /deep/ li{
    position: relative;
    z-index: 1;
    padding: 10px 0;
    margin: 0 3%;
    font-size: 12px;
    border-bottom: 1px solid #f5f5f5;
  }
  .commercialInsuranceDetail /deep/  li>div{
    display: inline-block;
    vertical-align: middle;
  }
  .commercialInsuranceDetail /deep/  li>div:nth-child(1){
    width: 47%;
    text-align: left;
  }
  .commercialInsuranceDetail /deep/ li>div:nth-child(2){
    width: 19%;
    background-color: #f4f4f4;
    text-align: center;
  }

  .commercialInsuranceDetail /deep/ .arrow:after {
    content: '';
    position: absolute;
    right: 5px;
    top: calc(50% - 4px);
    display: inline-block;
    width: 4px;
    height: 4px;
    border-right: 2px solid #ff7052;
    border-bottom: 2px solid #ff7052;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
  }

  .commercialInsuranceDetail /deep/ li>div:nth-child(3){
    width: 15%;
    text-align: center;
    position: relative;
  }

  .commercialInsuranceDetail /deep/ li>div:nth-child(4){
    width: 15%;
    text-align: right
  }

  .biList{
    margin-bottom: 20px;
  }
  .biList .tableTitle{
    margin: 0 3%;
  }

  .biList /deep/ .el-table th{
    background: #f2f2f2;
  }

  .biList /deep/ .el-input__inner,
  .biList /deep/ .el-select,
  .biList /deep/ .el-cascader{
    width: 100%;
    color: #ff7052;
  }

  .biList /deep/ .el-table td,
  .biList /deep/ .el-table th{
    padding: 5px 0;
  }

  .parameter{
    float: right;
  }
  .price{
    color: #ff7052;
  }

  .isVesselTax{
    display: none;
    position: relative;
    padding: 10px 0;
    margin: 0 3%;
    font-weight: bold;
    color: #727272;
    border-bottom: 1px solid #f5f5f5;
  }

  .isVesselTax .price{
    text-align: right;
    float: right;
    color: #ff7052;
  }

  .engageList{
    display: none;
  }
  .engageList.on{
    display: block;
    border-bottom: 1px solid #f5f5f5;
  }
  .engageList ul{
    padding: 5px 0 10px;
  }

  .engageListTitle{
    font-weight: bold;
    padding: 5px 3%;
    background: #f2f2f2;
  }
  .engageList /deep/ li{
    font-size: 12px;
    margin: 0 3%;
    padding: 6px 0;
  }
  .engageList /deep/ .details {
    /*color: #ff7052;*/
  }

  .importantNotifyList{
    display: none;
    margin-bottom: 20px;
  }
  .importantNotifyList.on{
    display: block;
    border-bottom: 1px solid #f5f5f5;
  }
  .importantNotifyListTitle{
    font-weight: bold;
    padding: 5px 3%;
    background: #f2f2f2;
  }
  .importantNotifyList /deep/ .openIframe{
    display: inline-block;
    padding: 3px 0;
    color: #ff7052;
  }
  .importantNotifyList /deep/ li{
    margin: 0 2%;
    padding: 6px 0;
  }

  .businessScore{
    width: 100% !important;
    padding: 10px 0;
    border-bottom: 1px solid #E5E5E5;
  }
  .businessScoreValue{
    color: #ff7052;
    font-weight: bold;
  }

  /* iframe弹窗 */
  .iframePreview{
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: 999;
    width: 100%;
    height: 100%;
    overflow: hidden;
    background-color: white;
    display: none;
  }

  .iframePreview iframe{
    background: #FFFFFF;
  }

  .closePreview{
    width: 50px;
    height: 50px;
    line-height: 50px;
    border-radius: 50%;
    font-size: 16px;
    position: absolute;
    bottom: 2vh;
    right: 2vw;
    z-index: 1000;
    text-align: center;
    color: #FFFFFF;
    background: #FF7052;
  }
</style>



// WEBPACK FOOTER //
// src/components/product/autoInsurance/taikang/premiumCalculation.vue